import { render, staticRenderFns } from "./ImpersonateEducationalModal.vue?vue&type=template&id=cc433b26&scoped=true"
import script from "./ImpersonateEducationalModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImpersonateEducationalModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ImpersonateEducationalModal.vue?vue&type=style&index=0&id=cc433b26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc433b26",
  null
  
)

export default component.exports